<!-- ================首页-协同备课详情====================-->
<template>
    <div class="tea-team-lesson-info-page">
        <home-head />
        <div class="tea-team-lesson-body">
            <div class="tea-team-lesson-inner">
                <!-- 标题区 -->
                <div class="page-header">
                    <div class="page-title-box">
                        <div class="page-title">协同备课详情</div>
                        <div class="page-subtitle">{{ lessonInfo.title || '--' }}</div>
                    </div>
                    <div class="page-actions">
                        <div class="back-btn" @click="goBack">
                            <span>返回列表</span>
                        </div>
                    </div>
                </div>

                <!-- 基本信息 -->
                <div class="info-section">
                    <div class="section-header">
                        <div class="section-title-group">
                            <div class="section-title">基本信息</div>
                            <div class="info-status-bar">
                                <span class="status-tag" :class="statusClass(lessonInfo.status)">{{ formatStatus(lessonInfo.status, lessonInfo.discussMode) }}</span>
                                <span class="status-tag release-tag" v-if="lessonInfo.status === 9">{{ formatReleaseStatus(lessonInfo.releaseStatus) }}</span>
                            </div>
                        </div>
                        <div class="section-extra">
                            <!-- 主备人操作按钮 -->
                            <div class="info-actions" v-if="lessonInfo.role === 0">
                                <span class="action-btn" v-if="(lessonInfo.status === 1 || lessonInfo.status === 2)" @click="handleUploadCaFile">上传初案</span>
                                <span class="action-btn" v-if="lessonInfo.status === 3 && lessonInfo.discussMode === 2" @click="handleUploadXzaFile">传修正案</span>
                                <span class="action-btn" v-if="lessonInfo.status === 1" @click="handleSubmit">开始备课</span>
                                <span class="action-btn" v-if="lessonInfo.status === 3 && lessonInfo.discussMode === 2" @click="beginSecondDiscuss">开始协同</span>
                                <span class="action-btn" v-if="((lessonInfo.status === 3 && lessonInfo.discussMode === 1) || lessonInfo.status === 5)" @click="handleUploadGaFile">上传共案</span>
                                <span class="action-btn" v-if="((lessonInfo.status === 3 && lessonInfo.discussMode === 1) || lessonInfo.status === 5)" @click="handleReflection">教学反思</span>
                                <span class="action-btn" v-if="(lessonInfo.status === 2 || lessonInfo.status === 4)" @click="handleStop">停止协同</span>
                                <span class="action-btn" v-if="lessonInfo.status === 8" @click="handleUploadReflection">上传反思</span>
                                <span class="action-btn" v-if="lessonInfo.status === 8" @click="handleEndLesson">结束备课</span>
                                <span class="action-btn" v-if="lessonInfo.status === 9 && (lessonInfo.releaseStatus === 0 || lessonInfo.releaseStatus === 3)" @click="handleRelease">发布备课</span>
                            </div>
                            <!-- 协备人/专家操作按钮 -->
                            <div class="info-actions" v-if="lessonInfo.role !== 2 && (lessonInfo.status === 2 || lessonInfo.status === 4)">
                                <span class="action-btn" @click="handleDiscuss">参与研讨</span>
                            </div>
                        </div>
                    </div>
                    <div class="base-info-content">
                        <div class="info-main">
                            <div class="info-title">[协同备课]{{ lessonInfo.title || '--' }}</div>
                            <div class="info-row">
                                <span class="info-label">学科信息：</span>
                                <span class="info-value">{{ lessonInfo.periodName || '--' }}、{{ lessonInfo.gradeName || '--' }}、{{ lessonInfo.subjectName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">备课级别：</span>
                                <span class="info-value">{{ lessonInfo.lessonLevelName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">备课时段：</span>
                                <span class="info-value">{{ formatTimeRange(lessonInfo) }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.discussMode !== 0">
                                <span class="info-label">备课研讨：</span>
                                <span class="info-value">{{ formatDiscussMode(lessonInfo.discussMode) }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">主备人：</span>
                                <span class="info-value">{{ lessonInfo.leadUserName || '--' }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.teamUserNames || teamUserText">
                                <span class="info-label">协备人：</span>
                                <span class="info-value">{{ lessonInfo.teamUserNames || teamUserText || '--' }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.guideNames || guideUserText">
                                <span class="info-label">指导专家：</span>
                                <span class="info-value">{{ lessonInfo.guideNames || guideUserText || '--' }}</span>
                            </div>
                        </div>
                        <div class="info-cover">
                            <img class="img-100" :src="lessonInfo.coverUrl || defaultCover" alt="备课封面" />
                        </div>
                    </div>
                </div>

                <!-- 协同备课时间进度 -->
                <div class="info-section" v-if="lessonInfo.discussMode !== 0">
                    <div class="section-title" style="margin-bottom: 20px;">协同备课时间进度</div>
                    <div class="timeline-container">
                        <!-- 上传初案 -->
                        <div class="timeline-item" :class="judgeStatusClass(1)">
                            <div class="timeline-dot"></div>
                            <div class="timeline-info">
                                <div class="timeline-title">上传初案</div>
                                <div class="timeline-time">
                                    <span>开始时间：{{ timestampToTime(lessonInfo.beginTime) }}</span>
                                    <span>完成时间：{{ timestampToTime(lessonInfo.firstDiscussBeginTime) }}</span>
                                </div>
                            </div>
                            <div class="timeline-status">{{ judgeStatusText(1) }}</div>
                        </div>
                        <!-- 一轮研讨 -->
                        <div class="timeline-item" :class="judgeStatusClass(2)">
                            <div class="timeline-dot"></div>
                            <div class="timeline-info">
                                <div class="timeline-title">一轮研讨</div>
                                <div class="timeline-time">
                                    <span>开始时间：{{ timestampToTime(lessonInfo.firstDiscussBeginTime) }}</span>
                                    <span>完成时间：{{ timestampToTime(lessonInfo.firstDiscussEndTime) }}</span>
                                </div>
                                <div class="timeline-join" v-if="oneDiscussList.length > 0">参与教师：{{ oneDiscussList.length }}人提交</div>
                            </div>
                            <div class="timeline-status">{{ judgeStatusText(2) }}</div>
                        </div>
                        <!-- 共案上传 / 初案修正 -->
                        <div class="timeline-item" :class="judgeStatusClass(3)">
                            <div class="timeline-dot"></div>
                            <div class="timeline-info">
                                <div class="timeline-title">{{ lessonInfo.discussMode === 1 ? '上传共案' : '初案修正' }}</div>
                                <div class="timeline-time">
                                    <span>开始时间：{{ timestampToTime(lessonInfo.firstDiscussEndTime) }}</span>
                                    <span>完成时间：{{ timestampToTime(lessonInfo.discussMode === 1 ? lessonInfo.gaFinishTime : lessonInfo.secondDiscussBeginTime) }}</span>
                                </div>
                            </div>
                            <div class="timeline-status">{{ judgeStatusText(3) }}</div>
                        </div>
                        <!-- 二轮研讨 -->
                        <div class="timeline-item" :class="judgeStatusClass(4)" v-if="lessonInfo.discussMode === 2">
                            <div class="timeline-dot"></div>
                            <div class="timeline-info">
                                <div class="timeline-title">二轮研讨</div>
                                <div class="timeline-time">
                                    <span>开始时间：{{ timestampToTime(lessonInfo.secondDiscussBeginTime) }}</span>
                                    <span>完成时间：{{ timestampToTime(lessonInfo.secondDiscussEndTime) }}</span>
                                </div>
                                <div class="timeline-join" v-if="twoDiscussList.length > 0">参与教师：{{ twoDiscussList.length }}人提交</div>
                            </div>
                            <div class="timeline-status">{{ judgeStatusText(4) }}</div>
                        </div>
                        <!-- 二轮共案 -->
                        <div class="timeline-item" :class="judgeStatusClass(5)" v-if="lessonInfo.discussMode === 2">
                            <div class="timeline-dot"></div>
                            <div class="timeline-info">
                                <div class="timeline-title">上传共案</div>
                                <div class="timeline-time">
                                    <span>开始时间：{{ timestampToTime(lessonInfo.secondDiscussEndTime) }}</span>
                                    <span>完成时间：{{ timestampToTime(lessonInfo.gaFinishTime) }}</span>
                                </div>
                            </div>
                            <div class="timeline-status">{{ judgeStatusText(5) }}</div>
                        </div>
                        <!-- 教学反思 -->
                        <div class="timeline-item" :class="judgeStatusClass(8)">
                            <div class="timeline-dot"></div>
                            <div class="timeline-info">
                                <div class="timeline-title">教学反思</div>
                                <div class="timeline-time">
                                    <span>开始时间：{{ timestampToTime(lessonInfo.gaFinishTime) }}</span>
                                    <span>完成时间：{{ timestampToTime(lessonInfo.finishTime) }}</span>
                                </div>
                                <div class="timeline-join" v-if="lessonInfo.refCount">参与教师：{{ lessonInfo.refCount }}人提交</div>
                            </div>
                            <div class="timeline-status">{{ judgeStatusText(8) }}</div>
                        </div>
                        <!-- 备课完成 -->
                        <div class="timeline-item" :class="lessonInfo.status === 9 ? 'status-done' : 'status-pending'">
                            <div class="timeline-dot"></div>
                            <div class="timeline-info">
                                <div class="timeline-title">备课完成</div>
                                <div class="timeline-time">完成时间：{{ timestampToTime(lessonInfo.finishTime) }}</div>
                            </div>
                            <div class="timeline-status">{{ lessonInfo.status === 9 ? '已完成' : '未完成' }}</div>
                        </div>
                    </div>
                </div>

                <!-- 附件内容 -->
                <div class="info-section">
                    <div class="section-title">附件内容</div>
                    <div class="attachment-container">
                        <!-- 初案 -->
                        <div class="attachment-block" v-if="hasCaFiles">
                            <div class="block-title">初案</div>
                            <template v-for="field in caFileFields" :key="field.key">
                                <div class="file-type-block" v-if="lessonInfo[field.field] && lessonInfo[field.field].length > 0">
                                    <div class="file-type-label">{{ field.label }}</div>
                                    <div class="file-list">
                                        <div class="file-item" v-for="item in lessonInfo[field.field]" :key="item.fileId">
                                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                                            <div class="file-actions">
                                                <span class="file-action" @click="viewFile(item)">预览</span>
                                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- 修正案 -->
                        <div class="attachment-block" v-if="lessonInfo.discussMode === 2 && hasXzaFiles">
                            <div class="block-title">修正案</div>
                            <template v-for="field in xzaFileFields" :key="field.key">
                                <div class="file-type-block" v-if="lessonInfo[field.field] && lessonInfo[field.field].length > 0">
                                    <div class="file-type-label">{{ field.label }}</div>
                                    <div class="file-list">
                                        <div class="file-item" v-for="item in lessonInfo[field.field]" :key="item.fileId">
                                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                                            <div class="file-actions">
                                                <span class="file-action" @click="viewFile(item)">预览</span>
                                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- 共案 -->
                        <div class="attachment-block" v-if="hasGaFiles">
                            <div class="block-title">共案</div>
                            <template v-for="field in gaFileFields" :key="field.key">
                                <div class="file-type-block" v-if="lessonInfo[field.field] && lessonInfo[field.field].length > 0">
                                    <div class="file-type-label">{{ field.label }}</div>
                                    <div class="file-list">
                                        <div class="file-item" v-for="item in lessonInfo[field.field]" :key="item.fileId">
                                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                                            <div class="file-actions">
                                                <span class="file-action" @click="viewFile(item)">预览</span>
                                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- 暂无附件 -->
                        <div class="empty-attachment" v-if="!hasCaFiles && !(lessonInfo.discussMode === 2 && hasXzaFiles) && !hasGaFiles">
                            <div class="empty-icon">
                                <img src="@/assets/image/data_empty.png" alt="暂无附件" />
                            </div>
                            <div class="empty-text">暂无附件</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 上传初案 -->
        <el-dialog title="上传初案" v-model="uploadCa" width="600px" @close="queryLessonInfo">
            <el-form label-width="80px">
                <el-form-item label="教案">
                    <el-upload v-model:file-list="jAFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 1, lessonType: 0, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="学案">
                    <el-upload v-model:file-list="xAFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 4, lessonType: 0, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="课件">
                    <el-upload v-model:file-list="kJFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 2, lessonType: 0, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="习题">
                    <el-upload v-model:file-list="xTFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 3, lessonType: 0, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 上传修正案 -->
        <el-dialog title="上传修正案" v-model="uploadXza" width="600px" @close="queryLessonInfo">
            <el-form label-width="80px">
                <el-form-item label="教案">
                    <el-upload v-model:file-list="ytjAFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 1, lessonType: 2, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="学案">
                    <el-upload v-model:file-list="ytxAFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 4, lessonType: 2, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="课件">
                    <el-upload v-model:file-list="ytkJFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 2, lessonType: 2, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="习题">
                    <el-upload v-model:file-list="ytxTFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 3, lessonType: 2, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 上传共案 -->
        <el-dialog title="上传共案" v-model="uploadGa" width="600px" @close="queryLessonInfo">
            <el-form label-width="80px">
                <el-form-item label="教案">
                    <el-upload v-model:file-list="gajAFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 1, lessonType: 1, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="学案">
                    <el-upload v-model:file-list="gaxAFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 4, lessonType: 1, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="课件">
                    <el-upload v-model:file-list="gakJFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 2, lessonType: 1, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="习题">
                    <el-upload v-model:file-list="gaxTFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/lesson/uploadFile'" :headers="{ token }"
                               :on-remove="handleRemove"
                               :data="{ fileType: 3, lessonType: 1, lessionId: lessonId }"
                               accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件，单个不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 上传教学反思 -->
        <el-dialog title="教学反思" v-model="isShowReflection" width="600px">
            <el-form label-width="90px">
                <el-form-item label="反思文件">
                    <el-upload v-model:file-list="refFileList" class="upload-demo"
                               :action="serviceUrl + '/businessservice/reflection/uploadFile'" :headers="{ token }"
                               :limit="1" :on-remove="handleRemove" :on-success="handleRefSuccess"
                               :before-upload="beforeRefUpload"
                               accept=".pdf,.ppt,.pptx,.doc,.docx">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip><div class="el-upload__tip">只允许上传1个.pdf,.ppt,.pptx,.doc,.docx格式文件，不超过200M。</div></template>
                    </el-upload>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="isShowReflection = false">取 消</el-button>
                <el-button type="primary" @click="submitReflection">确 定</el-button>
            </template>
        </el-dialog>

        <!-- 发布备课 -->
        <el-dialog title="发布备课" v-model="ckPeople" width="760px">
            <choosePeople :noShowIdList="noShowIdList" v-if="ckPeople" :showTitle="'选择人员'" ref="ckPeople" />
            <div style="color: #b22222; font-size: 13px; margin-top: 8px;">*主备人、协备人、指导专家默认可查看。</div>
            <template #footer>
                <el-button @click="closeCkPeople">取 消</el-button>
                <el-button type="primary" @click="submitCkPeopleForm">确 定</el-button>
            </template>
        </el-dialog>

        <!-- 附件预览 -->
        <el-image-viewer
            v-if="previewVisible"
            :url-list="previewSrcList"
            :initial-index="0"
            :hide-on-click-modal="true"
            @close="previewVisible = false"
        />
    </div>
</template>

<script>
import {
    lessonInfo,
    lessonSubmit,
    lessonStop,
    lessonEnd,
    lessonReflection,
    lessonUploadReflection,
    lessonRelease,
    delLessonFile,
} from "@/api/admin/lesson";
import { timestampToTime } from "@/utils/date";
import { downloadFile } from "@/utils/download";
import { serviceUrl } from "@/utils/global";
import homeHead from "@/components/common/homeHead.vue";
import choosePeople from "@/components/choosePeople.vue";
import { ElImageViewer } from "element-plus";

export default {
    components: { homeHead, choosePeople, ElImageViewer },
    name: "teaTeamLessonInfo",
    data() {
        return {
            timestampToTime,
            serviceUrl,
            token: this.$storage.get("token"),
            loading: false,
            lessonId: "",
            defaultCover: require("@/assets/logo/logo.png"),
            lessonInfo: {
                title: "",
                periodName: "",
                gradeName: "",
                subjectName: "",
                lessonLevelName: "",
                discussMode: 1,
                leadUserName: "",
                teamUserNames: "",
                guideNames: "",
                beginTime: "",
                endTime: "",
                finishTime: "",
                firstDiscussBeginTime: "",
                firstDiscussEndTime: "",
                secondDiscussBeginTime: "",
                secondDiscussEndTime: "",
                gaFinishTime: "",
                status: "",
                releaseStatus: "",
                coverUrl: "",
                refCount: 0,
                role: 2,
                jaFiles: [],
                xaFiles: [],
                kjFiles: [],
                xtFiles: [],
                ytjaFiles: [],
                ytxaFiles: [],
                ytkjFiles: [],
                ytxtFiles: [],
                gajaFiles: [],
                gaxaFiles: [],
                gakjFiles: [],
                gaxtFiles: [],
                teamUserList: [],
                guideUserList: [],
                oneDiscussList: [],
                twoDiscussList: [],
            },
            caFileFields: [
                { key: "ja", field: "jaFiles", label: "教案" },
                { key: "xa", field: "xaFiles", label: "学案" },
                { key: "kj", field: "kjFiles", label: "课件" },
                { key: "xt", field: "xtFiles", label: "习题" },
            ],
            xzaFileFields: [
                { key: "ytja", field: "ytjaFiles", label: "教案" },
                { key: "ytxa", field: "ytxaFiles", label: "学案" },
                { key: "ytkj", field: "ytkjFiles", label: "课件" },
                { key: "ytxt", field: "ytxtFiles", label: "习题" },
            ],
            gaFileFields: [
                { key: "gaja", field: "gajaFiles", label: "教案" },
                { key: "gaxa", field: "gaxaFiles", label: "学案" },
                { key: "gakj", field: "gakjFiles", label: "课件" },
                { key: "gaxt", field: "gaxtFiles", label: "习题" },
            ],
            // 初案上传
            uploadCa: false,
            jAFileList: [],
            xAFileList: [],
            kJFileList: [],
            xTFileList: [],
            // 修正案上传
            uploadXza: false,
            ytjAFileList: [],
            ytxAFileList: [],
            ytkJFileList: [],
            ytxTFileList: [],
            // 共案上传
            uploadGa: false,
            gajAFileList: [],
            gaxAFileList: [],
            gakJFileList: [],
            gaxTFileList: [],
            // 教学反思
            isShowReflection: false,
            reflectionForm: {
                lessonId: "",
                fileUrl: "",
            },
            refFileList: [],
            // 发布备课
            ckPeople: false,
            noShowIdList: [],
            // 删除文件缓冲
            delFileList: [],
            // 附件预览
            previewVisible: false,
            previewSrcList: [],
        };
    },
    computed: {
        teamUserText() {
            if (this.lessonInfo.teamUserNames) return "";
            const list = (this.lessonInfo.teamUserList || []).map(e => e.trueName || e.expertName || "");
            return list.join("、");
        },
        guideUserText() {
            if (this.lessonInfo.guideNames) return "";
            const list = (this.lessonInfo.guideUserList || []).map(e => e.trueName || e.expertName || "");
            return list.join("、");
        },
        oneDiscussList() {
            return this.lessonInfo.oneDiscussList || [];
        },
        twoDiscussList() {
            return this.lessonInfo.twoDiscussList || [];
        },
        hasCaFiles() {
            return this.caFileFields.some(f => this.lessonInfo[f.field] && this.lessonInfo[f.field].length > 0);
        },
        hasXzaFiles() {
            return this.xzaFileFields.some(f => this.lessonInfo[f.field] && this.lessonInfo[f.field].length > 0);
        },
        hasGaFiles() {
            return this.gaFileFields.some(f => this.lessonInfo[f.field] && this.lessonInfo[f.field].length > 0);
        },
    },
    created() {
        if (this.$route.query.lessonId) {
            this.lessonId = this.$route.query.lessonId;
            this.queryLessonInfo();
        }
    },
    mounted() {
        document.documentElement.classList.add("tea-team-lesson-scroll");
        document.body.classList.add("tea-team-lesson-scroll");
    },
    beforeUnmount() {
        document.documentElement.classList.remove("tea-team-lesson-scroll");
        document.body.classList.remove("tea-team-lesson-scroll");
    },
    methods: {
        queryLessonInfo() {
            // 清理待删除文件
            this.delFileList.forEach(url => {
                delLessonFile({ fileUrl: url }).catch(() => {});
            });
            this.delFileList = [];

            lessonInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data && res.data.code === 1) {
                    const data = res.data.data || {};
                    this.lessonInfo = { ...this.lessonInfo, ...data };
                    this.syncFileListFromLessonInfo();
                } else {
                    this.$message.error(res.data.msg || "获取备课信息失败");
                }
            }).catch(() => {});
        },
        syncFileListFromLessonInfo() {
            // 初案
            this.jAFileList = (this.lessonInfo.jaFiles || []).map(e => this.toUploadFile(e));
            this.xAFileList = (this.lessonInfo.xaFiles || []).map(e => this.toUploadFile(e));
            this.kJFileList = (this.lessonInfo.kjFiles || []).map(e => this.toUploadFile(e));
            this.xTFileList = (this.lessonInfo.xtFiles || []).map(e => this.toUploadFile(e));
            // 修正案
            this.ytjAFileList = (this.lessonInfo.ytjaFiles || []).map(e => this.toUploadFile(e));
            this.ytxAFileList = (this.lessonInfo.ytxaFiles || []).map(e => this.toUploadFile(e));
            this.ytkJFileList = (this.lessonInfo.ytkjFiles || []).map(e => this.toUploadFile(e));
            this.ytxTFileList = (this.lessonInfo.ytxtFiles || []).map(e => this.toUploadFile(e));
            // 共案
            this.gajAFileList = (this.lessonInfo.gajaFiles || []).map(e => this.toUploadFile(e));
            this.gaxAFileList = (this.lessonInfo.gaxaFiles || []).map(e => this.toUploadFile(e));
            this.gakJFileList = (this.lessonInfo.gakjFiles || []).map(e => this.toUploadFile(e));
            this.gaxTFileList = (this.lessonInfo.gaxtFiles || []).map(e => this.toUploadFile(e));
            // 反思
            this.refFileList = [];
            this.reflectionForm.fileUrl = "";
            if (this.lessonInfo.isRef === 1 && this.lessonInfo.reflection && this.lessonInfo.reflection.file) {
                const f = this.lessonInfo.reflection.file;
                this.refFileList = [this.toUploadFile(f)];
                this.reflectionForm.fileUrl = f.fileUrl;
            }
        },
        toUploadFile(e) {
            return {
                name: e.fileName,
                fileId: e.fileId,
                url: e.fileUrl,
                response: { data: e.fileUrl },
            };
        },
        formatStatus(status, discussMode) {
            if (status === 1) return "初始";
            if (status === 2) return "一轮研讨";
            if (status === 3 && discussMode == 2) return "初案修正";
            if (status === 3 && discussMode == 1) return "共案上传";
            if (status === 4 && discussMode == 2) return "二轮研讨";
            if (status === 5 && discussMode == 2) return "共案修正";
            if (status === 8) return "教学反思";
            if (status === 9) return "备课完成";
            return status || "--";
        },
        formatReleaseStatus(status) {
            if (status === 0) return "未发布";
            if (status === 1) return "审核中";
            if (status === 2) return "已发布";
            if (status === 3) return "已拒绝";
            return status || "--";
        },
        formatDiscussMode(val) {
            if (val == 1) return "一轮研讨";
            if (val == 2) return "二轮研讨";
            return "--";
        },
        formatTimeRange(row) {
            if (row.beginTime && row.endTime) {
                return timestampToTime(row.beginTime) + " 至 " + timestampToTime(row.endTime);
            }
            return "--";
        },
        statusClass(status) {
            if (status === 9) return "status-done";
            if (status === 2 || status === 4) return "status-active";
            return "status-default";
        },
        judgeStatusClass(step) {
            const status = this.judgeLessonStatus(step, this.lessonInfo.status);
            if (status === 3) return "status-done";
            if (status === 2) return "status-active";
            return "status-pending";
        },
        judgeStatusText(step) {
            const status = this.judgeLessonStatus(step, this.lessonInfo.status);
            if (status === 3) return "已完成";
            if (status === 2) return "进行中";
            return "未开始";
        },
        judgeLessonStatus(step, status) {
            // 1: 未开始 2: 进行中 3: 已完成
            const doneStatus = [3, 5, 8, 9];
            if (step === 1) {
                if (status === 1) return 2;
                if (doneStatus.includes(status) || status === 2 || status === 4) return 3;
            }
            if (step === 2) {
                if (status === 1) return 1;
                if (status === 2) return 2;
                if (doneStatus.includes(status) || status === 4) return 3;
            }
            if (step === 3) {
                if (status === 1 || status === 2) return 1;
                if (this.lessonInfo.discussMode === 1) {
                    if (status === 3) return 2;
                    if (doneStatus.includes(status)) return 3;
                } else {
                    if (status === 3) return 2;
                    if (doneStatus.includes(status) || status === 4 || status === 5) return 3;
                }
            }
            if (step === 4) {
                if (status === 1 || status === 2 || status === 3) return 1;
                if (status === 4) return 2;
                if (doneStatus.includes(status) || status === 5) return 3;
            }
            if (step === 5) {
                if (status === 1 || status === 2 || status === 3 || status === 4) return 1;
                if (status === 5) return 2;
                if (doneStatus.includes(status)) return 3;
            }
            if (step === 8) {
                if (status === 1 || status === 2 || status === 3 || status === 4 || status === 5) return 1;
                if (status === 8) return 2;
                if (status === 9) return 3;
            }
            return 1;
        },
        goBack() {
            this.$router.push({ path: "/tea/teaResearch", query: { tab: "team" } });
        },
        handleDownloadFile(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        viewFile(item) {
            if (item.status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览");
                return;
            }
            const previewList = this.gainFileImgList(item.imgUrl, item.pages);
            if (previewList && previewList.length > 0) {
                this.previewSrcList = previewList;
                this.previewVisible = true;
            } else if (item.fileUrl) {
                window.open(item.fileUrl, "_blank");
            } else {
                this.$message.info("暂无可预览内容");
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + "/" + i + ".png");
            }
            return list;
        },

        // ==================== 操作按钮 ====================
        handleUploadCaFile() {
            this.uploadCa = true;
        },
        handleUploadXzaFile() {
            this.uploadXza = true;
        },
        handleUploadGaFile() {
            this.uploadGa = true;
        },
        handleUploadReflection() {
            this.isShowReflection = true;
            this.reflectionForm.lessonId = this.lessonId;
        },

        // 开始备课 / 进入下一轮
        handleSubmit() {
            if (this.lessonInfo.status === 1) {
                if (!this.hasCaFiles) {
                    this.$message.error("请先上传初案");
                    return;
                }
            }
            if (this.lessonInfo.status === 3 && this.lessonInfo.discussMode === 2) {
                if (!this.hasXzaFiles) {
                    this.$message.error("请先上传修正案");
                    return;
                }
            }
            this.$confirm("确定开始协同备课吗？", "提示", { type: "warning" }).then(() => {
                lessonSubmit({ lessonId: this.lessonId }).then(res => {
                    if (res.data && res.data.code === 1) {
                        this.$message.success("操作成功");
                        this.queryLessonInfo();
                    } else {
                        this.$message.error(res.data.msg || "请求失败");
                    }
                }).catch(() => {});
            }).catch(() => {});
        },
        beginSecondDiscuss() {
            this.handleSubmit();
        },

        // 停止协同
        handleStop() {
            this.$confirm("确定停止当前协同阶段吗？", "提示", { type: "warning" }).then(() => {
                lessonStop({ lessonId: this.lessonId }).then(res => {
                    if (res.data && res.data.code === 1) {
                        this.$message.success("操作成功");
                        this.queryLessonInfo();
                    } else {
                        this.$message.error(res.data.msg || "操作失败");
                    }
                }).catch(() => {});
            }).catch(() => {});
        },

        // 进入教学反思
        handleReflection() {
            if (!this.hasGaFiles) {
                this.$message.error("请先上传共案");
                return;
            }
            this.$confirm("确定进入教学反思阶段吗？", "提示", { type: "warning" }).then(() => {
                lessonReflection({ lessonId: this.lessonId }).then(res => {
                    if (res.data && res.data.code === 1) {
                        this.$message.success("操作成功");
                        this.queryLessonInfo();
                    } else {
                        this.$message.error(res.data.msg || "请求失败");
                    }
                }).catch(() => {});
            }).catch(() => {});
        },

        // 结束备课
        handleEndLesson() {
            if (!this.hasGaFiles) {
                this.$message.error("请先上传共案");
                return;
            }
            this.$confirm("确定结束备课吗？", "提示", { type: "warning" }).then(() => {
                lessonEnd({ lessonId: this.lessonId }).then(res => {
                    if (res.data && res.data.code === 1) {
                        this.$message.success("操作成功");
                        this.queryLessonInfo();
                    } else {
                        this.$message.error(res.data.msg || "操作失败");
                    }
                }).catch(() => {});
            }).catch(() => {});
        },

        // 发布备课
        handleRelease() {
            this.noShowIdList = [];
            (this.lessonInfo.guideUserList || []).forEach(e => {
                this.noShowIdList.push(e.userId);
            });
            (this.lessonInfo.teamUserList || []).forEach(e => {
                this.noShowIdList.push(e.userId);
            });
            if (this.lessonInfo.leadUser) {
                this.noShowIdList.push(this.lessonInfo.leadUser);
            }
            this.ckPeople = true;
        },
        submitCkPeopleForm() {
            const checkList = [];
            if (this.$refs.ckPeople && this.$refs.ckPeople.checkList) {
                this.$refs.ckPeople.checkList.forEach(e => {
                    checkList.push(e.userId);
                });
            }
            lessonRelease({ lessonId: this.lessonId, viewUsers: checkList.toString() }).then(res => {
                if (res.data && res.data.code === 1) {
                    this.$message.success("已发布，请等待审核");
                    this.ckPeople = false;
                    this.queryLessonInfo();
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            }).catch(() => {});
        },
        closeCkPeople() {
            this.ckPeople = false;
        },

        // 上传反思文件
        submitReflection() {
            if (!this.reflectionForm.fileUrl) {
                this.$message.error("请上传教学反思文件");
                return;
            }
            lessonUploadReflection(this.reflectionForm).then(res => {
                if (res.data && res.data.code === 1) {
                    this.$message.success("上传成功");
                    this.isShowReflection = false;
                    this.queryLessonInfo();
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
            }).catch(() => {});
        },

        // 参与研讨
        handleDiscuss() {
            const routeUrl = this.$router.resolve({
                path: "/edu/lessonDiscuss",
                query: { lessonId: this.lessonId },
            });
            window.open(routeUrl.href, "_blank");
        },

        // ==================== 文件上传通用 ====================
        beforeJAUpload(rawFile) {
            const acceptTypes = [
                "application/pdf",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/msword",
            ];
            if (!acceptTypes.includes(rawFile.type)) {
                this.$message.error("文件必须是.pdf,.ppt,.pptx,.doc,.docx格式");
                return false;
            }
            if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error("文件大小不能超过200M");
                return false;
            }
            return true;
        },
        beforeRefUpload(rawFile) {
            return this.beforeJAUpload(rawFile);
        },
        handleRemove(file) {
            if (file.response && file.response.data) {
                this.delFileList.push(file.response.data);
            }
        },
        handleRefSuccess(response, uploadFile) {
            if (uploadFile.response && uploadFile.response.code === 1) {
                this.reflectionForm.fileUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败");
            }
        },
    },
};
</script>

<style scoped>
.tea-team-lesson-info-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto!important;
}

.tea-team-lesson-body {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0 80px 0;
    box-sizing: border-box;
    overflow-y: auto!important;
}


.tea-team-lesson-body::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.tea-team-lesson-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}
.tea-team-lesson-body::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}
.tea-team-lesson-body::-webkit-scrollbar-thumb:hover {
    background: #9a1b1b;
}

.tea-team-lesson-inner {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* 标题区 */
.page-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-title-box {
    display: flex;
    flex-direction: column;
}

.page-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 6px;
}

.page-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.page-actions {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 36px;
    line-height: 36px;
    padding: 0 32px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

/* 信息区块 */
.info-section {
    width: 100%;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1.5px solid #b22222;
    padding: 20px;
    box-sizing: border-box;
}

.section-title {
    font-size: 16px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    flex-shrink: 0;
}

.section-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f3f4f6;
    margin-bottom: 16px;
}

.section-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.section-extra {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    flex: 1;
    min-width: 0;
}

/* 基本信息 */
.base-info-content {
    width: 100%;
    display: flex;
    gap: 20px;
}

.info-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.info-status-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.info-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 16px;
    background-color: #ffffff;
    color: #b22222;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 13px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.action-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

.status-tag {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 13px;
    font-size: 12px;
    color: #ffffff;
    font-family: sans-serif;
    background-color: #4095e5;
}

.status-done {
    /* background-color: #81b337; */
}

.status-active {
    /* background-color: #ffbf6b; */
}

.status-default {
    /* background-color: #9ca3af; */
}

.release-tag {
    background-color: #b22222;
}

.info-title {
    font-size: 18px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
    line-height: 1.5;
    margin-bottom: 8px;
}

.info-row {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: sans-serif;
    line-height: 1.6;
}

.info-label {
    color: #4b5563;
    white-space: nowrap;
}

.info-value {
    color: #1f2937;
    flex: 1;
    word-break: break-all;
}

.info-cover {
    width: 300px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f3f4f6;
}

.info-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* 时间进度 */
.timeline-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
    padding-left: 10px;
}

.timeline-item {
    position: relative;
    padding-left: 24px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.timeline-item::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 8px;
    bottom: 0;
    width: 2px;
    background-color: #e5e7eb;
}

.timeline-item:last-child::before {
    display: none;
}

.timeline-dot {
    position: absolute;
    left: 0;
    top: 6px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #d1d5db;
    border: 2px solid #ffffff;
    box-shadow: 0 0 0 1px #d1d5db;
}

.timeline-item.status-done .timeline-dot {
    background-color: #81b337;
    box-shadow: 0 0 0 1px #81b337;
}

.timeline-item.status-active .timeline-dot {
    background-color: #ffbf6b;
    box-shadow: 0 0 0 1px #ffbf6b;
}

.timeline-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.timeline-title {
    font-size: 15px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
}

.timeline-time {
    font-size: 13px;
    color: #6b7280;
    font-family: sans-serif;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.timeline-join {
    font-size: 13px;
    color: #b22222;
    font-family: sans-serif;
}

.timeline-status {
    font-size: 13px;
    color: #6b7280;
    font-family: sans-serif;
    white-space: nowrap;
}

.timeline-item.status-done .timeline-status {
    color: #81b337;
}

.timeline-item.status-active .timeline-status {
    color: #f97316;
}

/* 附件 */
.attachment-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.attachment-block {
    width: 100%;
    border: 1px solid #f3f4f6;
    border-radius: 4px;
    padding: 14px;
    box-sizing: border-box;
}

.block-title {
    font-size: 15px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 12px;
}

.file-type-block {
    margin-bottom: 12px;
}

.file-type-block:last-child {
    margin-bottom: 0;
}

.file-type-label {
    font-size: 13px;
    color: #4b5563;
    font-family: sans-serif;
    margin-bottom: 8px;
    padding-left: 8px;
    border-left: 3px solid #b22222;
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background-color: #f9fafb;
    border-radius: 4px;
}

.file-name {
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.file-action {
    font-size: 13px;
    color: #b22222;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.file-action:hover {
    color: #9a1b1b;
    text-decoration: underline;
}

.empty-attachment {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
}

.empty-icon {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 响应式 */
@media (max-width: 1024px) {
    .base-info-content {
        flex-direction: column;
    }

    .info-cover {
        width: 100%;
        max-height: 300px;
    }
}

@media (max-width: 768px) {
    .page-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .info-section {
        padding: 14px;
    }

    .timeline-item {
        flex-direction: column;
        gap: 8px;
    }

    .file-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
}
</style>

<style>
html.tea-team-lesson-scroll,
body.tea-team-lesson-scroll {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

html.tea-team-lesson-scroll::-webkit-scrollbar,
body.tea-team-lesson-scroll::-webkit-scrollbar {
    display: none;
}
</style>
